<script lang="ts">
	import { format } from 'svelte-i18n';

	import { Icon, Text } from '@Shelly/shelly-design-system';

	import { CAMERA_CLOUD_STORAGE_GRADIENT_END } from 'src/helpers/camera_cloud_storage_helpers';
	import { cameraCloudStorageBenefits } from 'src/helpers/subscription_benefits_helpers';
</script>

<div class="ccs-benefits">
	<div class="ccs-benefit-header">
		<Text styleType="body-small" class="text-uppercase text-color-muted text-bold" noWrap>
			{$format('text_camera_cloud_storage_what_you_get', { default: 'What you get' })}
		</Text>
		<Text styleType="body-small" class="ccs-standard-label text-uppercase text-bold" noWrap>
			{$format('label_standard', { default: 'Standard' })}
		</Text>
		<Text styleType="body-small" class="ccs-storage-label text-uppercase text-bold" noWrap>
			{$format('text_camera_cloud_storage_label', { default: 'Camera Storage' })}
		</Text>
	</div>

	{#each cameraCloudStorageBenefits as benefit (benefit.title)}
		<div class="ccs-benefit-row">
			<div class="ccs-benefit-description">
				<Text styleType="controls-small" class="text-bold mb-xs">
					{$format(benefit.title, { default: benefit.titleDefault })}
				</Text>
				<Text styleType="body-small" class="text-color-muted">
					{$format(benefit.subtitle, { default: benefit.subtitleDefault })}
				</Text>
			</div>

			{#each [benefit.standard, benefit.cameraStorage] as value, column}
				<div class:ccs-storage-value={column === 1} class="ccs-benefit-value">
					{#if typeof value === 'boolean'}
						<Icon
							size="s"
							icon={value ? 'fas fa-check' : 'fas fa-times'}
							style={column === 1 && value
								? `color: ${CAMERA_CLOUD_STORAGE_GRADIENT_END};`
								: 'color: #8c9baa;'}
						/>
					{:else}
						{#if value.icon}
							<Icon
								size="s"
								icon="fas fa-check"
								style={column === 1
									? `color: ${CAMERA_CLOUD_STORAGE_GRADIENT_END};`
									: 'color: #8c9baa;'}
							/>
						{/if}
						{#if value.value}
							<span class="ccs-benefit-value-primary">{value.value}</span>
						{/if}
						<span class="ccs-benefit-value-label">
							{$format(value.label, { default: value.labelDefault })}
						</span>
					{/if}
				</div>
			{/each}
		</div>
	{/each}
</div>

<style>
	.ccs-benefits {
		width: 100%;
	}

	.ccs-benefit-header,
	.ccs-benefit-row {
		display: grid;
		grid-template-columns: minmax(0, 1fr) repeat(2, minmax(104px, 184px));
	}

	.ccs-benefit-header {
		align-items: center;
		min-height: 22px;
	}

	.ccs-benefit-header :global(.text) {
		min-width: 0;
	}

	:global(.ccs-standard-label),
	:global(.ccs-storage-label) {
		text-align: center;
	}

	:global(.ccs-standard-label) {
		color: var(--color-primary, #2491ff);
	}

	:global(.ccs-storage-label),
	.ccs-storage-value {
		color: #893bf2;
	}

	.ccs-benefit-row {
		align-items: stretch;
		border-bottom: 1px solid var(--color-2, #303235);
	}

	.ccs-benefit-description {
		display: flex;
		flex-direction: column;
		justify-content: center;
		min-width: 0;
		padding: 8px 0;
	}

	.ccs-benefit-value {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 2px;
		min-width: 0;
		padding: 8px;
		text-align: center;
	}

	.ccs-benefit-value-primary {
		font-size: 13px;
		font-weight: 700;
		line-height: 16px;
	}

	.ccs-benefit-value-label {
		font-size: 10px;
		font-weight: 500;
		line-height: 12px;
	}

	@media screen and (max-width: 639px) {
		.ccs-benefit-header,
		.ccs-benefit-row {
			grid-template-columns: minmax(130px, 1fr) repeat(2, 104px);
		}

		.ccs-benefits {
			overflow-x: auto;
		}
	}
</style>
